import { render, staticRenderFns } from "./LomMembers.vue?vue&type=template&id=1e56deb2"
import script from "./LomMembers.vue?vue&type=script&lang=js"
export * from "./LomMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports